// extracted by mini-css-extract-plugin
export var text_lead = "text-lead-module--text_lead--sHoHD";
export var Right = "text-lead-module----right--E4l8l";
export var Center = "text-lead-module----center--2CBjr";